import { useState, useEffect, useCallback } from "react";

import Tabela from "./Tabela";
import Grafico from "./Grafico";
import GraficoService from "../Services/GraficoService";
import "./visualizacaoGrafico.scss";

export default function VisualizacaoGrafico({ graphData }) {
  const printGraphs = () => {
    window.print();
  };

  const back = () => {
    window.history.back();
  };

  return (
    <div>
      <div className="d-flex justify-content-between my-4">
        <button className="global-btn-info shadow-none" onClick={back}>
          Voltar
        </button>
        <button
          className="global-btn-info justify-content-center shadow-none"
          onClick={printGraphs}
          style={{ width: 197 }}
        >
          Imprimir
        </button>
      </div>

      <section
        className="graph-section section-to-print "
        id="section-to-print"
      >
        {/* <Header fazenda={getFazenda(graphData)}></Header> */}
        {graphData.map((graph, i) => (
          <Section key={i} graph={graph} />
        ))}
      </section>
    </div>
  );
}

function Section({ graph }) {
  const [convertedGraph, setConvertedGraph] = useState(null);

  const [selectedSafras, setSelectedSafras] = useState([]);

  const handleChangeCheckBox = useCallback(
    (row) => {
      if (selectedSafras.includes(row.safra)) {
        if (selectedSafras.length > 2)
          setSelectedSafras(
            selectedSafras.filter((category) => row.safra !== category)
          );
      } else {
        setSelectedSafras(
          [...selectedSafras, row.safra].sort(
            (firstElement, secondElement) => firstElement - secondElement
          )
        );
      }
    },
    [convertedGraph, selectedSafras]
  );

  const isCheckedCheckBox = useCallback(
    (safra) => {
      return selectedSafras.includes(safra);
    },
    [selectedSafras]
  );

  useEffect(() => {
    const convertedGraph = GraficoService.convertToGraphData(
      graph,
      selectedSafras
    );
    setSelectedSafras(convertedGraph.options.xaxis.categories);
  }, [graph]);

  useEffect(() => {
    setConvertedGraph(GraficoService.convertToGraphData(graph, selectedSafras));
  }, [graph, selectedSafras]);

  return (
    <div className="card border border-primary mb-5">
      <div className="card-header bg-primary border border-primary text-center py-0">
        <div className="row g-0">
          <div className="col-8 d-flex justify-content-end align-self-center">
            <h5 className="card-title fw-bold text-white py-1 m-0">
              Gráfico de Evolução de Rebanho Nelore: {graph.caracteristica}
            </h5>
          </div>
          <div className="col-4 d-flex justify-content-end gx-2">
            <button
              className="global-btn-info justify-content-center shadow-none"
              style={{ width: 197 }}
            >
              Extrair Gráfico
            </button>
          </div>
        </div>
      </div>
      <div className="card-body p-0 pb-3">
        <div className="row row-cols-1 row-cols-sm-1 row-cols-lg-2 g-3 g-lg-0">
          <div className="col">
            <div className="d-flex flex-column text-center align-items-center m-4">
              <h5 className="text-primary fw-bold">1 AG - FEV/2021</h5>
              <h6 className="text-dark fw-bold">{graph.filter}</h6>
              {convertedGraph && (
                <Grafico graph={graph} graphData={convertedGraph}></Grafico>
              )}
            </div>
          </div>
          <div className="col">
            <div className="m-4">
              <div>
                <Tabela
                  graph={graph}
                  changeCheckBox={handleChangeCheckBox}
                  isCheckedCheckBox={isCheckedCheckBox}
                ></Tabela>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
